import React from 'react';
//import styles from './App.module';
import './App.scss';
import { CourseCard, ICourse } from '../CourseCard';

export interface IAppProps {
  courses?: ICourse[];
}

export const App = (props: IAppProps) => {

  if (props.courses && props.courses.length) {
    return (
      <div className="row justify-content-md-center" data-masonry={"{'percentPosition': true}"}>
        {props.courses.map((course: ICourse, i: number) =>
          <CourseCard key={i} course={course} />
        )}
      </div>
    );
  } else {
    return (<div />);
  }
}

export default App;